"use client"

import { HEADER_ICON_MAP } from '@/shared/constants/icon-map'
import useIconAction from '@/shared/hooks/useIconAction'
import { HeaderIconName } from '@/shared/types/type/icon'
import { Typography } from '@/shared/ui/atoms'
import { CustomButton } from '@/shared/ui/molecules'
interface TypingHeaderProps {
  title?: string
  leftButtons?: HeaderIconName[]
  rightButtons?: HeaderIconName[]
}

const TypingHeader = ({ title = '', leftButtons, rightButtons }: TypingHeaderProps) => {
  const { getAction } = useIconAction()

  return (
    <header className="sticky top-0 z-[101] py-[14px] pl-4 pr-[14px] flex items-center justify-between w-full bg-white">
      <div className="flex items-center justify-between gap-[14px]">
        {leftButtons && leftButtons.map((item, index) => {
          const IconComponent = HEADER_ICON_MAP[item as HeaderIconName]
          return (
            <CustomButton
              key={`btn-left-${index}`}
              onClick={getAction(item)}
            >
              <IconComponent />
            </CustomButton>
          )
        })}
      </div>
      <div className="flex items-center justify-between gap-[14px]">
        {rightButtons && rightButtons.map((item, index) => {
          const IconComponent = HEADER_ICON_MAP[item as HeaderIconName]
          return (
            <CustomButton
              key={`btn-right-${index}`}
              onClick={getAction(item)}
            >
              <IconComponent />
            </CustomButton>
          )
        })}
      </div>
      <Typography size={18} lineHeight={25} className="absolute left-1/2 -translate-x-1/2 text-center text-gray-900 font-medium">{title}</Typography>
    </header>
  )
}

export default TypingHeader